export const ACCOUNT_LOGIN = 'ACCOUNT_LOGIN';
export const accountLogin = (username, password) => ({
  type: ACCOUNT_LOGIN,
  payload: {
    username,
    password,
  },
});

export const ACCOUNT_GET_ALL = 'ACCOUNT_GET_ALL';
export const accountGetAll = () => ({
  type: ACCOUNT_GET_ALL,
  payload: {
  },
});

export const ACCOUNT_UPDATE = 'ACCOUNT_UPDATE';
export const accountUpdate = (id, data) => ({
  type: ACCOUNT_UPDATE,
  payload: {
    id,
    data,
  },
});

export const ACCOUNT_CREATE = 'ACCOUNT_CREATE';
export const accountCreate = (username, password, displayName) => ({
  type: ACCOUNT_CREATE,
  payload: {
    username,
    password,
    displayName,
  },
});
